/**
 * Hub human login contract (Unified Identity D3d).
 *
 * Controls session remains in unicomply-rules — see docs/IDENTITY_LOGIN.md.
 *
 * Deployed lanes (ci/qa/pd) always set REACT_APP_IDENTITY_BASE_URL (or
 * REACT_APP_MCM_URL). Auth helpers fail closed via requireIdentityBaseUrl()
 * in services/auth.ts when the origin is unset.
 */

/** JWT audience sent to affableone-identity for Hub sessions. */
export const HUB_IDENTITY_AUDIENCE = "unicomply-hub";

/**
 * Identity sidecar auth paths (MCM proxy → affableone-identity).
 *
 * Base URL already includes `/api/affableflow` (see REACT_APP_IDENTITY_BASE_URL).
 * Paths must NOT repeat `/api` or login hits
 * `{host}/api/affableflow/api/v2/auth/login` → 404 Not Found.
 *
 * Hub forgot/reset password uses Rules OTP + `/api/v1/auth/reset-password`.
 */
export const IDENTITY_AUTH_PATHS = {
  login: "/v2/auth/login",
  forgotPassword: "/v2/auth/forgot-password",
  resetPassword: "/v2/auth/reset-password",
  changePassword: "/v2/auth/change-password",
  oidcStart: "/v2/auth/oidc/start",
  oidcCallback: "/v2/auth/oidc/callback",
  selectOrganization: "/v2/auth/select-organization",
  /** MCM onboarding status (mounted under /api/affableflow). */
  onboardingStatus: "/v1/identity/onboarding/status",
  /** MCM UniComply Hub OIDC signup draft + authorize URL (AB#10394). */
  unicomplySignupOidcStart: "/v2/unicomply/signup/oidc/start",
} as const;

/** Rules federation path — loads Hub domain context after identity JWT (D3c). */
export const RULES_DOMAIN_CONTEXT_PATH = "/api/v1/federation/domain-context";
